var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['stat-item']},[_c('div',{class:[_vm.$style['stat-item__value'], _vm.colorClass && _vm.$style[_vm.colorClass]],attrs:{"data-stat-value":""}},[_vm._t("default")],2),_c('span',{class:_vm.$style['stat-item__caption']},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }